export default __webpack_public_path__ + "static/media/nakshi-full.71a73657.png";